










import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { envCongif } from '../../shared/env.config';
import { CLIENT_NAMES } from './constant';
const cssPrefix: string = 'mysonicwall-info';
@Component({
  components: {},
})
export default class MysonicwallInfo extends SwExtendedVue {
  cssPrefix: string = cssPrefix;
  showDialog: boolean = true;

  @Prop({ type: Boolean, default: false, required: true })
  showMySonicwallInfo: any;

  @Prop({ type: String, default: '', required: true })
  currentClientName: any;

  get clientName() {
    return this.currentClientName;
  }

  iframeURL =
    this.clientName === CLIENT_NAMES.MYSONICWALL
      ? `${envCongif.msw_url}/help/helpang.htm`
      : 'https://securitynews.sonicwall.com/capture-cloud-security-center';
}
